<template >
    <div v-if="show" class=" bg-[rgba(93,93,152,0.45)]  px-2 py-2 rounded-lg flex  gap-2 justify-center w-fit overflow-x-auto">
            <div v-for="(action, index) in action_data" :key="index">
                <!-- Conditionally render the div based on action.visibility -->
                <div v-if="action.visibility" @click="action_OnClick(action)"
                    class="flex justify-center items-center gap-[0.5] cursor-pointer text-white text-xs px-3 py-2 bg-[#626288] rounded-lg hover:bg-[#c67700]">
                    <i :class="action.action_icon"></i>
                    <div class="text-nowrap text-center">{{ action.action_name }}</div>
                </div>
            </div>
            <AppButton
                class="text-white"
                v-bind:visibility="true" 
                left_icon="fa-regular fa-circle-xmark fa-xl"
                emitType="close"
                @close="close"
            />
        </div>
    </template>
<script>
    import AppButton from '@/components/button.vue'
 export default {
    name:'AppActionCard',
    components:{
        AppButton,
    },
    props:{
        action_data:{
            type:Array,
            default: ()=>{
            }
        },
        show:{
            type: Boolean,
            default: () => false
        },
        visibility:{
            type: Boolean,
            default: () => false
        }
    },

    methods:{
        action_OnClick(content){
            console.log(content)
            this.$emit('action-clicked', content)
        },

        close(){
        
            this.$emit('close')
        },
    }
 }

</script>



<style>
.scroll-style{
    scrollbar-color: gray transparent;
    scrollbar-width: thin;
}

</style>